import type { NetworkPayload } from "../../../composites";
import type { ManualEnrollmentPayload, DirectDepositManualForm } from "./types";

export const getManualEnrollmentPayload = (
  formData: DirectDepositManualForm,
): ManualEnrollmentPayload => {
  const { accountId: account, employer, allocationMethod } = formData || {};
  const payload: ManualEnrollmentPayload = {
    account,
    employer_name: employer,
    value: 100,
    value_type: "percentage",
  };

  if (allocationMethod === "percentage") {
    payload.value = formData?.valuePercent || 100;
  } else if (allocationMethod === "cents") {
    payload.value_type = allocationMethod;
    payload.value = formData?.valueCents || 0;
  }

  return payload;
};

export const API = {
  getSSOToken: (): NetworkPayload => {
    return {
      url: "direct_deposit/sso",
      options: {
        method: "POST",
        payload: {},
        isJsonResponse: true,
      },
    };
  },
  getManualEnrollmentDocument: (
    formData: DirectDepositManualForm,
  ): NetworkPayload<ManualEnrollmentPayload> => {
    const payload = getManualEnrollmentPayload(formData);
    return {
      url: `direct_deposit/pdf`,
      options: {
        method: "POST",
        payload,
        isJsonResponse: true,
      },
    };
  },
};
